import WRAP from "WRAP-JS";
/* eslint-disable */
WRAP.Geo.Bridge.GoogleMaps = function(map) {

  this.context_type = 'Canvas';
  this.zoom_limit = 32;
  this.min_zoom = 0;
  this.max_zoom = this.zoom_limit;
  this.extent_ratio = 1.0;//1.5;
  this.pixel_ratio = window.devicePixelRatio;
  this.ownerDocument = map.getDiv().ownerDocument || document;
  var self = this;
  self.valid = true;
  self.center = [0,0];
  self.zoom = 0;
  self.extent = null;
  self.size = [0,0];
  self.tile = {};
  self.active_tile = [];
  var projection;

  function tileID(z, y, x) { return self.id+"/"+z+"/"+y+"/"+x; }

  (this.ready = function() {
    return ( (projection = map.getProjection()) && map.getDiv().offsetWidth && map.getDiv().offsetHeight );
  })();

  this.updateView = function() {}

  this.setView = function(view, update) {
    this.view = view;
    this.updateView = update;
  }

  this.refresh = function() {
    google.maps.event.trigger(map, "resize");
    if ( self.refresh_timer )
      clearInterval(this.refresh_timer);
    self.refresh_timer = setInterval(function() {
      if ( self.ready() ) {
        clearInterval(self.refresh_timer);
        self.update();
      }
    }, 1);
  }

  this.update = function(force) {
    if ( self.ready() ) {
      var zoom = map.getZoom();
      if ( zoom < self.min_zoom ) {
        map.setCenter(new google.maps.LatLng(self.center[1], self.center[0]));
        map.setZoom(self.min_zoom);
        return;
      }
      if ( zoom > self.max_zoom ) {
        map.setCenter(new google.maps.LatLng(self.center[1], self.center[0]));
        map.setZoom(self.max_zoom);
        return;
      }
      var tile_band = Math.pow(2,zoom);
      var band = tile_band*256;
      var tile_size = 256/tile_band;
      var c = map.getCenter();
      var center = [c.lng(), c.lat()];
      center[0] = (center[0]+360)%360;
      var size = [map.getDiv().offsetWidth, map.getDiv().offsetHeight];
      if ( self.zoom != zoom ) {
        self.zoom = zoom;
        self.valid = false;
      }
      if ( self.center[0] != center[0] || self.center[1] != center[1] ) {
        self.center = center;
        self.valid = false;
      }
      if ( self.size[0] != size[0] || self.size[1] != size[1] ) {
        self.size = size;
        self.valid = false;
      }
      if ( !self.valid ) {
        self.valid = true;
        var cp = projection.fromLatLngToPoint(c);
        var hw = (size[0]/tile_band/2)*self.extent_ratio;
        var hh = (size[1]/tile_band/2)*self.extent_ratio;
        var min_x = Math.floor((cp.x-hw)/tile_size);
        var max_x = Math.floor((cp.x+hw)/tile_size);
        var min_y = tile_band-1-Math.floor((cp.y+hh)/tile_size);
        var max_y = tile_band-1-Math.floor((cp.y-hh)/tile_size);
        if ( min_y < 0 )
          min_y = 0;
        if ( max_y >= tile_band )
          max_y = tile_band-1;
        self.extent = [min_x*256-band/2, (max_y+1)*256-band/2, (max_x+1)*256-band/2, min_y*256-band/2];
        self.updateView(self.center, self.zoom, self.size, self.extent, force);
      }
    }
  }

  this.setCenter = function(center) {
    if ( !self.ready() )
      return;
//console.log("GM setCenter "+center[0]+","+center[1])
    map.setCenter(new google.maps.LatLng(center[1], center[0]));
    self.update();
  }

  this.setZoom = function(zoom) {
    if ( !self.ready() )
      return;
    if ( zoom < self.min_zoom )
      zoom = self.min_zoom;
    if ( zoom > self.max_zoom )
      zoom = self.max_zoom;
    map.setZoom(Math.floor(zoom));
    self.update();
  }

  this.setZoomRange = function(min, max) {
    self.min_zoom = isNaN(min)?0:min;
    self.max_zoom = isNaN(max)?self.zoom_limit:max;
  }

  this.enableScroll = function(enable) {
    map.setOptions({draggable:enable});
  }

  this.render = function(canvas, origin) {    // Canvas Type
    var tile_band = Math.pow(2,self.zoom);
    var band = tile_band*256;
    var ht = tile_band/2;
    var x = Math.floor((origin[0]+band/2)/256);
    var w = Math.ceil(canvas.width/256);
    var y = Math.floor((origin[1]+band/2-256)/256);
    var h = Math.ceil(canvas.height/256);
    var ox = ((x-ht)*256)-origin[0];
    var oy = ((y-ht)*256+256)-origin[1];

    function renderTile(x, y, z, canvas, cx, cy) {
      cx = (cx+band)%band;
      x = (x+tile_band)%tile_band;
      var normalized_id = tileID(z, y, x);

      var tile = last_tile[normalized_id];
      var cvs = (tile && tile.canvas) || self.makeCanvas();
      cvs.ctx.clearRect(0, 0, 256, 256);
      cvs.ctx.drawImage(canvas, cx, cy, 256, 256, 0, 0, 256, 256);
      self.tile[normalized_id] = {
        canvas:cvs,
        view:self.id, x:x, y:y, z:z
      }
      for ( var i = 0 ; i < self.active_tile.length ; i++ ) {
        var cvs = self.active_tile[i];
        if ( cvs.normalized_id == normalized_id ) {
          cvs.ctx.clearRect(0, 0, 256, 256);
          cvs.ctx.drawImage(canvas, cx, cy, 256, 256, 0, 0, 256, 256);
        }
      }
    }

    var last_tile = self.tile;
    self.tile = {};
    var cy = oy;
    for ( var yy = 0 ; yy < h ; yy++ ) {
      var cx = ox;
      for ( var xx = 0 ; xx < w ; xx++ ) {
        renderTile(x+xx, y-yy, self.zoom, canvas, cx, cy);
        cx += 256;
      }
      cy += 256;
    }
  }

  this.makeCanvas = function(normalized_id) {
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 256;
    canvas.ctx = canvas.getContext('2d');
    canvas.normalized_id = normalized_id;
    return canvas;
  }

  function OverlayMapType(tileSize) {
    this.tileSize = tileSize;
  }

  OverlayMapType.prototype.getTile = function(coord, z/*, ownerDocument*/) {
    var m = Math.pow(2,z);
    var x = coord.x;
    var y = m-coord.y-1;
    x = (x+m)%m;
    var normalized_id = tileID(z,y,x);
    var cvs = self.makeCanvas(normalized_id);
    self.active_tile.push(cvs);
    var tile = self.tile[normalized_id];
    if ( tile ) {
      cvs.ctx.clearRect(0, 0, 256, 256);
      cvs.ctx.drawImage(tile.canvas, 0, 0, 256, 256, 0, 0, 256, 256);
    }
    return cvs;
  }

  OverlayMapType.prototype.releaseTile = function(cvs) {
    var i = self.active_tile.indexOf(cvs);
    if ( i >= 0 )
      self.active_tile.splice(i, 1);
  }

  var index = map.overlayMapTypes.length;
  map.overlayMapTypes.push(null); // reserve maptype placeholder
  map.overlayMapTypes.setAt(index,new OverlayMapType(new google.maps.Size(256, 256)));
  google.maps.event.addListener(map, 'idle', function() {self.update(true);});
  google.maps.event.addListener(map, 'bounds_changed', function() {self.update(false);});
  /**
   * 【変更箇所】WRAP.Geo.Bridge.GoogleMapsの初期化時にはrefreshを実行しない。
   *  refreshをすると、GoogleMapを表示するまでreadyを実行し続ける。readyはブラウザのリフローが走る実装なのでループし続けるのはコスト的に好ましくない
   *  refreshはswitchMapのタイミングで呼ばれるので、初期化時に呼ぶ必要もないためコメントアウト。
   */
  // self.refresh();
}
/* eslint-enable */